import React from 'react';
import { BookOpenIcon, GiftIcon, ZapIcon, CreditCardIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { images } from '../../data/site';
const badges = [{
  icon: BookOpenIcon,
  label: '6 Clinical Volumes'
}, {
  icon: GiftIcon,
  label: '5 Professional Bonuses'
}, {
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: CreditCardIcon,
  label: 'One-Time Payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
const imagine = ['You know which facial characteristics to review.', 'You understand the principles behind dental proportions.', 'You recognize the importance of gingival relationships.', 'You have a structured process for reviewing the aesthetic proposal before presenting it to your patient.'];
export function FinalCTA() {
  return <section className="w-full bg-navy-950 px-4 py-16 text-white sm:py-20" aria-labelledby="final-heading" data-id="element-126" data-mp="q83pj6etejky">
      <div className="mx-auto max-w-3xl text-center" data-id="element-127" data-mp="labysfpwp3ic">
        <p className="font-display text-sm font-extrabold uppercase tracking-widest text-gold-300" data-id="element-128" data-mp="l7g0gqa5cctd">Your next smile design deserves a clearer plan</p>
        <h2 id="final-heading" className="mt-4 font-display text-[1.8rem] font-black leading-tight sm:text-5xl" data-id="element-129" data-mp="uz3mgbnxp1ng">
          Stop Relying on Guesswork. <span className="text-gold-400" data-id="element-130" data-mp="7a14f2pe16sf">Start Building a More Structured Approach</span> to Aesthetic Dentistry.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-131" data-mp="gafv6hl4fe3b">Imagine opening your next smile design case with a clear understanding of what you need to evaluate.</p>
        <ul className="mx-auto mt-6 max-w-xl space-y-3 text-left" data-id="element-132" data-mp="bdpfhvd8akif">
          {imagine.map(line => <li key={line} className="rounded-xl border-l-4 border-gold-400 bg-navy-800 px-4 py-3 text-[15px] font-medium text-white/90" data-id="element-133" data-mp="1rrflx8rtlkv8">
              {line}
            </li>)}
        </ul>
        <p className="mt-6 text-base leading-relaxed text-white/80" data-id="element-134" data-mp="kfg4e8toa6o0">
          You don’t need to memorize every aesthetic principle overnight. You need a reliable educational reference that helps you continue developing your clinical understanding.
        </p>

        <img src={images.mockup} alt="Complete Smile Design Roadmap package" className="mx-auto mt-8 w-full max-w-md" data-id="element-135" data-mp="yccvmbdpdq5f" />

        <p className="mt-6 font-display text-lg font-extrabold uppercase" data-id="element-136" data-mp="1kj2j3q711ja">Get the complete Smile Design Roadmap™</p>
        <p className="mt-1 font-display text-5xl font-black text-gold-400 sm:text-6xl" data-id="element-137" data-mp="5luydqznuizx">
          Today only $27 <span className="text-xl text-white" data-id="element-138" data-mp="fe0muqqpeiad">USD</span>
        </p>

        <div className="mt-6" data-id="element-139" data-mp="ffbq8pg8lo0y">
          <ScarcityBar data-id="element-140" data-mp="3e40qm195p8ll" />
        </div>
        <div className="mt-6" data-id="element-141" data-mp="3e2zhi2bpaw6i">
          <CTAButton label="Yes! I want my Smile Design Roadmap™" sublabel="Instant access · automatic currency conversion" data-id="element-142" data-mp="3e3r26i3rf9i0" />
        </div>
        <div className="mt-8" data-id="element-143" data-mp="3bjcm4kqukhrb">
          <CountdownTimer data-id="element-144" data-mp="3bi9to8dvm79a" />
        </div>

        <ul className="mx-auto mt-8 grid max-w-xl grid-cols-2 gap-x-3 gap-y-2.5 text-left" data-id="element-145" data-mp="3bh8fvw5h76nv">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-[13px] font-semibold text-white/85" data-id="element-146" data-mp="31kdkhm4i1mdt">
              <Icon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-147" data-mp="2xis2jmd3yhwr" />
              {label}
            </li>)}
        </ul>
        <p className="mt-8 text-[15px] text-white/70" data-id="element-148" data-mp="2smjrol5y1ave">Start building a more organized approach to aesthetic smile planning today.</p>
      </div>
    </section>;
}